import React from 'react';
const ReloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.5 9V8C2.5 4.96243 4.96243 2.5 8 2.5C9.10679 2.5 10.1372 2.82692 11 3.38947"
        stroke="#3574F0"
        strokeLinecap="round"
      />
      <path
        d="M5 12.6105C5.86278 13.1731 6.89321 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8V7"
        stroke="#3574F0"
        strokeLinecap="round"
      />
      <path
        d="M0.499725 7.50003L2.49976 9.49976L4.49974 7.49998"
        stroke="#3574F0"
        strokeLinecap="round"
      />
      <path
        d="M11.4998 8.5L13.4998 6.50018L15.4998 8.5"
        stroke="#3574F0"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default ReloadIcon;
